import React, { useState, useEffect } from "react";
import { app, FrameContexts } from "@microsoft/teams-js";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, FluentProvider, webLightTheme } from '@fluentui/react-components';
import { CustomDropdown } from '../components/CustomDropdown';
import { fetchSmartFormTemplates } from '../services/SurveyService';
import "../styles/TranscriptConsent.scss";

const FormSelectionScene = () => {
  const [ready, setReady] = useState(false);
  const [selectedForm, setSelectedForm] = useState<{ id: number; surveyCodedId: string; name: string } | null>(null);
  const [formOptions, setFormOptions] = useState<{ value: string; label: string; surveyCodedId: string }[]>([]);

  const navigate = useNavigate();
  const location = useLocation();
  const referenceCode = location.state?.referenceCode || "";

  useEffect(() => {
    const setup = async () => {
      await app.initialize();
      try {
        const context = await app.getContext();
        if (context.page.frameContext !== FrameContexts.sidePanel) {
          setReady(false);
          return;
        }
        try {
          const templates = await fetchSmartFormTemplates();
          const options = templates.map((template: { id: number; name: string; surveyCodedId: string }) => ({ 
            value: template.id, 
            label: template.name,
            surveyCodedId: template.surveyCodedId 
          }));
          setFormOptions(options);
          setReady(true);
        } catch (error) {
          console.error("Failed to load form options", error);
          setReady(false);
        }
      } catch (error) {
        setReady(false);
      }
    };
    setup();
  }, []);

  if (!ready) {
    return (
      <div style={{ padding: "16px" }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <FluentProvider theme={webLightTheme}>
      <div style={{ display: "flex", flexDirection: "column", height: "90vh", padding: "16px" }}>
        <div>
          <Button
            appearance="subtle"
            icon={<span style={{display:'inline-block',transform:'rotate(180deg)'}}>&#8594;</span>}
            onClick={() => navigate('/employeeDetails', { state: { referenceCode } })}
            aria-label="Back"
          />
        </div>

        <div style={{ marginTop: "16px" }}>
          <h4>Health Partners Note Assistant</h4>
          <p>{referenceCode}</p>
        </div>

        <div style={{ marginTop: "24px" }}>
          <CustomDropdown
            label="Select Clinical Form"
            options={formOptions}
            value={selectedForm?.id.toString() || ""}
            onChange={e => {
              const selectedId = Number(e.target.value);
              const selectedOption = formOptions.find(option => Number(option.value) === selectedId);
              if (selectedOption) {
                setSelectedForm({
                  id: selectedId,
                  surveyCodedId: selectedOption.surveyCodedId,
                  name: selectedOption.label
                });
              }
            }}
            placeholder="Select a form"
          />
        </div>

        <div style={{ flexGrow: 1 }}></div>

        <div style={{ marginBottom: "10px", display: "flex", justifyContent: "center" }}>
          <Button 
            appearance="primary" 
            onClick={() => navigate(`/observationForm`, { state: { selectedForm, referenceCode } })} 
            style={{ backgroundColor: "#6264A7", color: "#fff" }}
            disabled={!selectedForm}
          >
            OK
          </Button >
        </div>
      </div>
    </FluentProvider>
  );
};

export default FormSelectionScene;
